(() => {
  const initializeComparisons = (root = document) => {
    root.querySelectorAll('[data-format-compare]').forEach((frame) => {
      if (frame.dataset.initialized === 'true') return;
      const range = frame.querySelector('[data-format-compare-range]');
      if (!range) return;
      const update = () => {
        frame.style.setProperty('--compare-position', `${range.value}%`);
        range.setAttribute('aria-valuetext', `${range.value}% ${frame.querySelector('.format-compare__label--pouch')?.textContent}, ${100 - Number(range.value)}% ${frame.querySelector('.format-compare__label--bag')?.textContent}`);
      };
      range.addEventListener('input', update);
      let dragging = false;
      const move = (event) => {
        const bounds = frame.getBoundingClientRect();
        range.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100))));
        update();
      };
      range.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        dragging = true;
        range.setPointerCapture(event.pointerId);
        range.focus({ preventScroll: true });
        move(event);
      });
      range.addEventListener('pointermove', (event) => { if (dragging) move(event); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => range.addEventListener(name, () => { dragging = false; }));
      update();
      frame.dataset.initialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeComparisons(), { once: true });
  } else {
    initializeComparisons();
  }
  document.addEventListener('shopify:section:load', (event) => initializeComparisons(event.target));

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mobile-menu__panel a');
    if (link) link.closest('details').open = false;
    document.querySelectorAll('.mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.mobile-menu[open]');
    if (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
})();

// Only expose a review entry when its populated target exists.
(() => {
  const syncReviewEntries = () => {
    const target = document.querySelector('#recenze[data-review-strip]');
    document.querySelectorAll('[data-vezelo-review-link]').forEach((link) => {
      link.hidden = !target || Boolean(document.querySelector('.owner-reviews'));
      if (target?.dataset.reviewEntryLabel) link.querySelector('[data-review-entry-label]').textContent = target.dataset.reviewEntryLabel;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncReviewEntries, { once: true });
  } else {
    syncReviewEntries();
  }
  document.addEventListener('shopify:section:load', syncReviewEntries);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncReviewEntries));
})();
